module.exports = __webpack_public_path__ + "static/media/cc.40e57d4e.jpg";